import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';

import { provideStripe } from './provideStripe';
import { StripeFactoryService } from './stripe-factory.service';

@NgModule({
  providers: [],
})
export class StripeModule {
  constructor(
    private stripeFactory: StripeFactoryService,
    @Optional() @SkipSelf() parentModule?: StripeModule
  ) {
    if (parentModule) {
      throw new Error('StripeModule is already loaded.');
    }
    this.stripeFactory.create();
  }

  public static forRoot(
    publishableKey: string
  ): ModuleWithProviders<StripeModule> {
    return {
      ngModule: StripeModule,
      providers: [...provideStripe(publishableKey)],
    };
  }
}
